/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Issue_Missing_MappingInputs */

const en_issue_missing_mapping = /** @type {(inputs: Issue_Missing_MappingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`has no code in the destination system`)
};

/**
* | output |
* | --- |
* | "has no code in the destination system" |
*
* @param {Issue_Missing_MappingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const issue_missing_mapping = /** @type {((inputs?: Issue_Missing_MappingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issue_Missing_MappingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_issue_missing_mapping(inputs)
});